import { DocMetaData } from "./docMetaData";
import axiosInstance from "./axiosSetup";
import { transformApiResponse } from "./normalizeDocMetaData";
  import { AxiosError } from "axios";

export interface GetDocMetaDataResponse {
    file: File;
    entityType?: string;
    entity?: string;
    fileName: string;
    documentType?: string;
    authorDate?: string ;
    documentDate?: string; 
}

//main function
export const getDocMetaData = async (
    files: File[],
    onProgress: (percent: number) => void,
    useMock: boolean,
    showError: (msg: string) => void,
): Promise<DocMetaData[]> => {

    


    const totalFiles = files.length;
    let completedFiles = 0;

    const results: DocMetaData[] = [];

    const uploadSingleFile = async (file: File): Promise<void> => {
        const formData = new FormData();
        formData.append("file",file);
        const fileName = file.name;

        try {
          
            const response = await axiosInstance.post<GetDocMetaDataResponse>(
                "/uploader/extract-metadata", 
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",

                    },
                }
            );

            const data = response.data;
            console.log("extracted data is  in getdocmetadata", data);

            //Map API response to DocMetaData

            const transformedData = transformApiResponse(data,file);
            console.log("transformedData is", transformedData);

            results.push(transformedData);

            

        } catch (error: unknown) {
            if (error instanceof AxiosError) {
                console.log("failed to extract metadata for file", file.name,error);
                showError(error?.response?.data.detail);
            }
        } finally {
            completedFiles ++ ;
            const percent = Math.round((completedFiles / totalFiles) * 100);
            // console.log('percent is ',percent)
            onProgress(percent);
        }
    };  
    

    //Upload all files in parallel
    await Promise.all(files.map(file => uploadSingleFile(file)));

    return results;

};